import Loading from '@/shared/components/Carregando';
import MyContext from '@/shared/contexts/AppContext';
import { PerInternFilters } from './PerInternFilters';
import { PerInternModals } from './PerInternModals';
import { PerInternTable } from './PerInternTable';
import { useContext } from 'react';
import { useDataTableState } from '@/shared/components/tables/useDataTableState';
import { usePerIntern } from './usePerIntern';

export default function AttendanceSheetsPerInternPage() {
  const context = useContext(MyContext);
  if (!context) throw new Error('Contexto deve ser usado dentro de um Provedor.');

  const tableState = useDataTableState('ano');
  tableState.pageSize = 1000;
  const {
    estagiarioId, setEstagiarioId,
    estagio, setEstagio,
    estagiarios, estagios,
    estagiarioNome,
    registros, handleBuscar,
    isExecuting, handleCriarFolha,
    selectedItem, setSelectedItem,
    folhaSelecionada, setFolhaSelecionada,
    showModalCriarFolha, setShowModalCriarFolha,
    showModalNotificacaoIndividual, setShowModalNotificacaoIndividual,
    showModalResponsavel, setShowModalResponsavel,
    showModalAssinaturas, setShowModalAssinaturas,
    folhaParaAssinaturas, setFolhaParaAssinaturas,
    loaded
  } = usePerIntern();

  if (!loaded)
    return <Loading />;

  return (
    <>
      <div className="row">
        <div className="col-md-8">
          <h3>Folhas de Frequências</h3>
          <span className="blockquote-footer pb-4 text-end">
            Registros de presenças e faltas do(a) estagiário(a).
          </span>
        </div>
      </div>
      <hr />

      <PerInternFilters
        estagiarioId={estagiarioId}
        setEstagiarioId={setEstagiarioId}
        estagio={estagio}
        setEstagio={setEstagio}
        estagiarios={estagiarios}
        estagios={estagios}
        tableState={tableState}
      />

      {registros && (
        <PerInternTable
          registros={registros}
          tableState={tableState}
          handleBuscar={handleBuscar}
          setSelectedItem={setSelectedItem}
          setShowModalCriarFolha={setShowModalCriarFolha}
          setFolhaSelecionada={setFolhaSelecionada}
          setShowModalResponsavel={setShowModalResponsavel}
          setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
          setFolhaParaAssinaturas={setFolhaParaAssinaturas}
          setShowModalAssinaturas={setShowModalAssinaturas}
        />
      )}

      <PerInternModals
        folhaSelecionada={folhaSelecionada}
        selectedItem={selectedItem}
        estagioId={estagio?.id}
        showModalResponsavel={showModalResponsavel}
        setShowModalResponsavel={setShowModalResponsavel}
        showModalNotificacaoIndividual={showModalNotificacaoIndividual}
        setShowModalNotificacaoIndividual={setShowModalNotificacaoIndividual}
        showModalCriarFolha={showModalCriarFolha}
        setShowModalCriarFolha={setShowModalCriarFolha}
        isExecuting={isExecuting}
        handleCriarFolha={handleCriarFolha}
        estagiarioNome={estagiarioNome}
        showModalAssinaturas={showModalAssinaturas}
        setShowModalAssinaturas={setShowModalAssinaturas}
        folhaParaAssinaturas={folhaParaAssinaturas}
        onResponsavelAlterado={handleBuscar}
      />
    </>
  );
}
